/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import React from 'react';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import appTheme from '../../common/theme/appTheme.json';
import FlightInfo from './FlightInfo';
import PlansBodyWrapper, { HEADER_BUFFER_HEIGHT, MISSION_PLAN_TITLE_HEIGHT } from '../PlansBodyWrapper';

export interface FlightInfoContainerProps {}

const useStyles = makeStyles({
  root: {
    overflow: 'auto',
    background: appTheme.mptPrimaryBackgroundColor,
    justifyContent: 'center',
  },
});

const FlightInfoContainer = (props: FlightInfoContainerProps) => {
  const classes = useStyles();

  return (
    <PlansBodyWrapper title="Mission details">
      <Box
        display="flex"
        className={classes.root}
        sx={{
          height: `calc(100vh - ${HEADER_BUFFER_HEIGHT + MISSION_PLAN_TITLE_HEIGHT}px)`,
        }}
      >
        <Box width="598px" minWidth="598px">
          <FlightInfo />
        </Box>
      </Box>
    </PlansBodyWrapper>
  );
};

export default FlightInfoContainer;
